<template>
  <nav class="pagination" v-if="pages > 1">
    <button
      v-if="searchParams.offset > 0"
      @click="paginate({ offset: searchParams.offset - searchParams.limit }, searchParams, true)"
      class="pagination__PreviousPage"
    >
      &lt; {{ $store.getters.getStringTranslation('previous') }}
    </button>

    <ul class="pagination__Pages">
      <template v-if="current > 5">
        <li>
          <button @click="paginate({ offset: 0 }, searchParams, true)" :class="{ 'is-Active': current === 1 }">
            1
          </button>
        </li>
        <li><a>...</a></li>
      </template>
      <li v-for="n in pagesBetween" :key="n.id">
        <button
          @click="paginate({ offset: n * searchParams.limit }, searchParams, true)"
          :class="{ 'is-Active': current === n + 1 }"
        >
          {{ n + 1 }}
        </button>
      </li>
      <template v-if="current + 4 < pages">
        <li><a>...</a></li>
        <li>
          <button
            @click="paginate({ offset: (pages - 1) * searchParams.limit }, searchParams, true)"
            :class="{ 'is-Active': current === pages }"
          >
            {{ pages }}
          </button>
        </li>
      </template>
    </ul>

    <button
      v-if="current !== pages"
      @click="paginate({ offset: searchParams.offset + searchParams.limit }, searchParams, true)"
      class="pagination__NextPage"
    >
      {{ $store.getters.getStringTranslation('next') }} &gt;
    </button>
  </nav>
</template>

<script>
export default {
  props: ['searchParams', 'count', 'dispatch'],
  methods: {
    async paginate(params) {
      window.scrollTo(0, 0)
      await this.$store.dispatch(this.dispatch, params)
    },
  },
  computed: {
    current() {
      return this.searchParams.offset / this.searchParams.limit + 1
    },
    pages() {
      return Math.round(Math.ceil(this.count / this.searchParams.limit))
    },
    pagesBetween() {
      return [...Array(this.pages).keys()].filter((n) => n < this.current + 6 && n > this.current - 6)
    },
  },
}
</script>
